import { render, staticRenderFns } from "./messege_isClose.vue?vue&type=template&id=705b5092&scoped=true"
import script from "./messege_isClose.vue?vue&type=script&lang=js"
export * from "./messege_isClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b5092",
  null
  
)

export default component.exports